export default __webpack_public_path__ + "assets/webgl/fail.57679388.png";